import { Component } from '@angular/core';
import { NavController, NavParams ,AlertController,ModalController,ToastController,ViewController, GESTURE_GO_BACK_SWIPE} from 'ionic-angular';
import { Headers , RequestOptions } from '@angular/http';

import {Api} from "../../providers/api";
import {CartManager} from "../../providers/cart-manager";
import {MsgManager} from "../../providers/msg-manager";
import {Events} from 'ionic-angular';
import { SpinnerDialog } from 'ionic-native';
import {LoginPage} from '../login/login';
import {GVLogger} from "../../services/gv-logger";
import {Customer} from "../../providers/data";

@Component({
  selector: 'page-webstore-user-self-edit',
  templateUrl: 'webstore-user-self-edit.html',
})
export class WebstoreUserSelfEditPage {

  accountActive = true;
  shippingActive = false;
  shippingServices:any = [];
  shippingServicesAll:any = [];



  customer : any;
  customerName = "";
  callStatus = 0;
  tempCust:any;
  formStatus = false;
  buttonText = "";
  firstName = "";
  lastName = "";
  phone = "";
  pageTitle = "";
  emailReadOnly= false;
  userNameReadOnly= false;



  passwordHidden = true;

  userUnique = true; // true for update only

  constructor(private nav:NavController,
    private api:Api,
    private params: NavParams,
    private cartManager:CartManager,
    private msgManager:MsgManager,
    private viewController:ViewController,
    private toastController:ToastController,
    private events:Events,
    private gVLogger: GVLogger){

    this.customer = this.params.get("user");


    for(let s of this.customer.customersDTO.shippingServiceDTOs){
      s.isAddFlag = false;
      s.isEditFlag = false;
      this.shippingServices.push(s);
    }

    //this.shippingServices = this.customer.customersDTO.shippingServiceDTOs;



    this.customerName = this.params.get("customer").name;
    this.buttonText = this.params.get("button");
    this.tempCust = this.customer;


    if(!this.customer.userName){
      this.customer.userName ="";
    }
    if(!this.customer.pass){
      this.customer.pass = "";
    }
    if(!this.customer.firstName){
      this.customer.firstName = "";
    }
    if(!this.customer.lastName){
      this.customer.lastName = "";
    }
    if(!this.customer.phoneNo){
      this.customer.phoneNo = '';
    }


    if(this.buttonText == "CREATE"){
      this.pageTitle = "Create User - ";
      this.userUnique = false;
    }else{
      this.pageTitle = "Update User - ";
      this.userNameReadOnly = true;
      this.emailReadOnly = true;
    }

    this.getAllShippingServies();
  }


  serverCall(){
    if(this.buttonText == "CREATE"){
      this.createCall();
    }else{
      this.updateCall();
    }
  }

  createCall(){

    this.validateForm();
    if(this.formStatus){
       this.gVLogger.log("Create Call...");
       SpinnerDialog.show(this.msgManager.getLoadingMsg());
       this.api.post("customers/createUserByCustomer",this.genrateBody()).map(res => res.json()).subscribe(result =>{
         if(result.status == "200"){
           this.callStatus = 1;
           this.viewController.dismiss(this.returnData(true));
           this.toastMsg(result.message);
           this.events.publish("webstoreUserUpdated");
         }else if(result.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
            this.nav.setRoot(LoginPage);
          }else{
           this.customer = this.tempCust;
           this.viewController.dismiss(this.returnData(false));
           this.toastMsg(result.message);
         }
         SpinnerDialog.hide();
       }, error =>{
         this.customer = this.tempCust;
         this.toastMsg(this.msgManager.getWentWrongMsg());
         this.viewController.dismiss(this.returnData(false));
         SpinnerDialog.hide();
       });
    }else{
      this.toastMsg("Complete Form First.");
    }
  }

  updateCall(){
    this.validateForm();
    if(this.formStatus){
      this.gVLogger.log("Update Call...");
      SpinnerDialog.show(this.msgManager.getLoadingMsg());
       this.api.post("customers/editUserByCustomer",this.genrateBody()).map(res => res.json()).subscribe(result =>{
         if(result.status == "200"){
           this.callStatus = 1;
           this.toastMsg(result.message);
           this.events.publish("webstoreUserUpdated");
           this.viewController.dismiss(this.returnData(true));
         }else if(result.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
            this.nav.setRoot(LoginPage);
          }else{
           this.customer = this.tempCust;
           this.viewController.dismiss(this.returnData(false));
           this.toastMsg(result.message);
         }
         SpinnerDialog.hide();
       }, error =>{
         this.customer = this.tempCust;
         this.toastMsg(this.msgManager.getWentWrongMsg());
         this.viewController.dismiss(this.returnData(false));
         SpinnerDialog.hide();
       });
    }else{
      this.toastMsg("Complete Form First.");
    }
  }

  genrateBody(){
    // if (this.customer.userStatus == "1") {
    //   this.customer.userStatus = "1"
    // }else{
    //   this.customer.userStatus = "0"
    // }

     let body = {
        customerId: this.cartManager.getCustomerID(),
        changeBy: this.customer.id,
        userFirstName: this.customer.firstName ,
        userLastName: this.customer.lastName,
        userName: this.customer.userName,
        userEmail: this.customer.email,
        password: this.customer.pass,
        userStatus: 1,
        userPhone: this.customer.phoneNo,
        userRole: 2
    };


    return body;
  }

  validateForm(){
    if( this.customer.userName == "" ||
    this.customer.password == "" ||
    this.customer.firstName == "" ||
    this.customer.lastName == "" ||
    this.customer.email == "" ||
    this.customer.phoneNo == ""){
      this.formStatus = false;
    }else{

          this.formStatus = true;

      }
  }

  cancelPopup(){
    this.viewController.dismiss(this.returnData(false));
  }

  toastMsg(msg){
    let taost = this.toastController.create({
        message: msg,
        duration: 3000
    });
    taost.present();
  }

  returnData(goBack){
    if (this.customer.userStatus == "1") {
      this.customer.userStatus = 1
    }else{
      this.customer.userStatus = 0
    }
    return {
      customer: this.customer,
      callStatus: this.callStatus,
      goBack: goBack
    }
  }


   checkUsernameUniqeness(){

    this.gVLogger.log(this.customer.userName +" -- - - ");
   // var body:any = { "query":};

    // let body = new FormData();
    // body.append('query', this.customer.userName );

    let body ={
      query:this.customer.userName
    };

    this.api.get('customers/availability',body)
      .map(res => res.json())
        .subscribe(resp => {
          this.gVLogger.log(JSON.stringify(resp));
          if(resp.status=="200"){
            this.userUnique = true;

          }else if(resp.status=="500"){
            this.userUnique = false;
            this.msgManager.toastMsg("User name not available please choose other.");
            // let toast = this.toastController.create({
            //   message: "User name not available please choose other.",
            //   duration: 3000
            // });
            // toast.present();
          }else if(resp.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
            this.nav.setRoot(LoginPage);
          }
        });
  }


  togglePasswordField(){
    var input = document.getElementById('passwordFiled').firstElementChild;

    if(this.passwordHidden){
     input.setAttribute("type", "text");
    }else{
      input.setAttribute("type", "password");
    }

    this.passwordHidden = !this.passwordHidden;
  }

  validateFormShip(){
    let valid = true;
    for(let s of this.shippingServices){
      if(s.isAddFlag == true || s.isEditFlag == true){
        valid = false;
      }
    }
    return valid;
  }


  updateShipping(){

    if(this.validateFormShip()){



    let postJSON = this.customer.customersDTO;
    this.gVLogger.log(this.customer);

    postJSON.logedinUser = Number(this.cartManager.getSalesManId());
    postJSON.shippingServiceDTOs = this.shippingServices;

//     var postJSON = {
//       logedinUser: Number(this.cartManager.getSalesManId()),
//       company: this.customerCreateForm.value.company,
//       salesPersonCode: this.customerCreateForm.value.iUser,
//       name: this.customerCreateForm.value.name,
//       userName: this.customerCreateForm.value.userName,
//       password: this.customerCreateForm.value.password,
//       prefixCustomerId: this.customerCreateForm.value.prefix,
//       phone: this.customerCreateForm.value.phone,
//       taxGroup: this.customerCreateForm.value.taxGroup,
//       customerGroup: this.customerCreateForm.value.customerGroup,
//       email: this.customerCreateForm.value.email,
//       locationsDTOs: locations
//      }


    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({
      headers: headers
    });


this.api.post("customers/add",JSON.stringify(postJSON),options)
.map(res => res.json())
  .subscribe(data => {
if(data.status == "200"){
  this.msgManager.toastMsg("Shipping services updated successfully");
  //   let toast = this.toastController.create({
  //   message: "Shipping services updated successfully",
  //   duration: 3000
  // });
  // toast.present();

// TODO: return data logic

this.customer.customersDTO.shippingServiceDTOs = this.shippingServices;
this.viewController.dismiss(this.returnData(true));


}else if(data.status == "401"){ // check for session out
    this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
  }

 });


}else{
  this.msgManager.toastMsg("Unable to proceed");
  // let toast = this.toastController.create({
  //   message: "Unable to proceed",
  //   duration: 3000
  // });
  // toast.present();
}




  }


  addShip(obj){

    if(obj.shippingServiceId == 0){
      this.msgManager.toastMsg("Please select a shipping service first");
    }else if(obj.shippingServiceValue.trim() == ""){
      this.msgManager.toastMsg("Please enter a value for shipping service id");
    }else{
      obj.isEditFlag = false;
      obj.isAddFlag = false;
    }

  }

  removeship(obj){
    this.shippingServices = this.shippingServices.filter((o)=> o.id != obj.id);
  }




  addShipping(){
    this.shippingServices.push({
      adpCustomerId:this.customer.customersDTO.adpCustomerId ,
      customerId:this.customer.customersDTO.id,
      id :  this.getRandomId(),
      isAddFlag :  true,
      isEditFlag : false,
      shippingServiceId  :   0,
      shippingServiceValue  :""});
  }


  getRandomId(){
    return -Math.floor(Math.random() * 1000) + 1
  }


  accountTab(){
    this.accountActive = true;
    this.shippingActive = false;

    this.gVLogger.log("account");
  }

  shippingTab(){
    this.accountActive = false;
    this.shippingActive = true;

    this.gVLogger.log("ship");
  }


  translateShippingServiceId(id){
    for(let s of this.shippingServicesAll){
      if(s.id == id)
      return s.description;
    }
  }


  getAllShippingServies(){
    // this.api.geJazzba("lookups/search/%20/0/100/shippingServices").map(res=>res.json())
    this.api.get("lookup/shippingServices?customerId="+Customer.id).map(res=>res.json())
      .subscribe((result)=>{
        this.shippingServicesAll = result.data;
      },(err)=>{

      });
  }


}



// WEBPACK FOOTER //
// ./src/pages/webstore-user-self-edit/webstore-user-self-edit.ts